function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 35,
  fill: "url(#paint0_linear_dai)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.726 18.5175H35.0585C43.1683 18.5175 49.3157 22.8764 51.6026 29.2193H55.7558V33.053H52.4772C52.5414 33.6588 52.5741 34.276 52.5741 34.903V34.9972C52.5741 35.7032 52.5327 36.3972 52.4516 37.0769H55.7558V40.9106H51.5236C49.1764 47.1652 43.0766 51.4826 35.0585 51.4826H21.726V40.9106H17.093V37.0769H21.726V33.053H17.093V29.2193H21.726V18.5175ZM25.4532 40.9106V48.0435H35.0585C40.9859 48.0435 45.3897 45.1867 47.4396 40.9106H25.4532ZM48.5815 37.0769H25.4532V33.053H48.5874C48.6732 33.6862 48.7169 34.3353 48.7169 34.9972V35.0914C48.7169 35.7685 48.6712 36.4314 48.5815 37.0769ZM35.0585 21.9509C41.0132 21.9509 45.4302 24.8831 47.4678 29.2193H25.4532V21.9509H35.0585Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_dai",
  x1: 35,
  y1: -9.91667,
  x2: 35,
  y2: 77.35,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBCC5F"
})));

var SvgDai = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDai, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dai.239cab11.svg";
export { ForwardRef as ReactComponent };